<template>
  <div class>
    <div class="tabs-nav flex" :class="layout" :style="{ backgroundColor }">
      <div
        @click="changeTabTabs(i)"
        class="tab-name"
        :style="{ color: activeTab === i ? color : ''  }"
        :class="[{ active: activeTab === i }, type]"
        v-for="(v, i) in tabList"
        :key="i"
      >
        {{ v.tabTitle }}
      </div>
      <div class="tips" v-if="tabList.length <= 0">请添加分类名称</div>
    </div>
    <div class="tab-body">
      <div class="goods-list"
        :class="{
          'show-column': goodShowType === 'twoColumn',
          'three-column': goodShowType === 'threeColumn',
          scroll: goodShowType === 'scroll',
        }"
      >
        <div v-for="(item, index) in goodsList" :key="index" class="goods-item">
          <div class="image-wrapper2" 
              :class="{
                'height351': goodShowType === 'big',
                'height165': goodShowType === 'twoColumn',
                'height106': goodShowType === 'threeColumn',
                'height112': goodShowType === 'scroll',
                }"
          >
            <img :src="item.spuMainPic" />
            <div class="watermark" v-if="watermark">
              <img :src="watermark" />
            </div>
          </div>
          <span class="title2 clamp">{{ item.wxshopSpuName }}</span>
          <div class="price-box flex">
            <span class="price flex-1">{{ item.showPrice }}</span>
            <!-- <span class="btn  round primary" style="padding: 10rpx 10px">购买</span> -->
          </div>
          <div
            class="sold-out-wrapper"
            v-if="!item.stockNum || item.stockNum <= 0"
          >
            <div class="content">当前门店售罄</div>
          </div>
        </div>
        <div class="tips" v-if="goodsList.length <= 0">请添加分组商品</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
export default {
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "span"
    },
    layout: {
      type: String,
      default: "flex-start"
    },
    backgroundColor: {
      type: String,
      default: "#f0f0f0",
    },
    color: {
      type: String,
      default: "#2B2B2B",
    },
    goodShowType: {
      type: String,
      default: "big",
    },
  },
  data() {
    return {
      goodsList: [],
      activeTab: 0,
      watermark: ""
    };
  },
  methods: {
    async queryWatermark(groupId, storeCode) {
      const { result } = await this.$store.dispatch(
        "queryGroupGoodsWatermark",
        {
          groupId,
          storeCode
        }
      );
      const { groupLabelPic } = result;
      this.watermark = groupLabelPic;
    },
    changeTabTabs(i) {
      // if (this.activeTab === i) {
      //   return;
      // }
      this.activeTab = i;
      const groupId = this.tabList[i].groupGoods.groupId || "";
      this.queryGroupGoods(groupId);
    },
    async queryGroupGoods(groupId) {
      const { storeCode } = getLoginUser();
      this.goodsList = [];
      if (!groupId) {
        return;
      }
      this.queryWatermark(groupId, storeCode);
      const { result } = await this.$store.dispatch("queryGroupGoods", {
        pageSize: 99999,
        pageNo: 1,
        storeCode,
        groupId
      });
      const { records } = result;
      this.goodsList = records;
    }
  }
};
</script>

<style lang="scss" type="scoped">
.tabs-nav {
  background: #fff;
  padding: 15px;
  overflow-x: auto;
  white-space: nowrap;
  .tab-name {
    position: relative;
    font-size: 14px;
    padding: 5px 15px;
    cursor: pointer;
    &.text.active {
      color: #e50065;
      font-weight: bold;
    }
    &.button.active {
      background: #e50065;
      border-radius: 30px;
      color: #fff;
    }
    &.line.active:after {
      position: absolute;
      content: "";
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 50%;
      height: 3px;
      background: #e50065;
      border-radius: 30px;
    }
  }
}

.goods-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 16px;
  background: transparent;
  overflow: hidden;
  &.show-column {
    display: flex;
    flex-wrap: wrap;
    flex-direction: flex-start;
    justify-content: space-between;
    .goods-item {
      width: 48%;
      &:nth-child(2n + 1) {
        margin-right: 4%;
      }
    }
  }
  &.three-column {
    // column-count: 3;
    // column-gap: 5px;
    // display: inline-block;
    display: flex;
    flex-wrap: wrap;
    flex-direction: flex-start;
    .goods-item {
      width: 30%;
      margin-right: 3%;
    }
  }
  &.scroll {
    display: flex;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 10px;
    margin-bottom: -10px;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    .goods-item {
      flex-basis: 112px;
      flex-shrink: 0;
      white-space: nowrap;
      white-space: nowrap;
      margin-right: 4%;
    }
  }
  
  .goods-item {
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    // width: 48%;
    width: 100%;
    background: #fff;
    padding-bottom: 20px;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .image-wrapper2 {
    position: relative;
    width: 100%;
    height: 165px;
    border-radius: 3px;
    overflow: hidden;
    .watermark {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }

  .title2 {
    font-size: 14px;
    margin: 10px;
    // box-sizing: border-box;
    min-height: 34px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .price-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    padding: 0 10px;
    color: #e50163;
  }

  .price {
    font-size: 12px;
    color: #e50163;
    line-height: 1;

    &:before {
      content: "￥";
      font-size: 13px;
    }
  }
}

.goods-item {
  position: relative;
  .sold-out-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5);

    .content {
      position: absolute;
      top: 82px;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.5);
      width: 93px;
      color: #fff;
      text-align: center;
      border-radius: 30px;
      padding: 10px 5px;
    }
  }
}

.tips {
  color: #999;
  font-size: 12px;
}
.goods-list {
  .height351{
    height: 351px;
  }
  .height165{
    height: 165px;
  }
  .height106{
    height: 106px;
  }
  .height112{
    height: 112px;
  }
}
</style>
